import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import { type OddsGridIndexProps, OddsGridWithQuery } from '@cx-modules/odds-grid';

export const OddsGrid = (props: OddsGridIndexProps) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <OddsGridWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
